export default {
  public_vapid_key: 'BM8aNiI2IsUfSLvfdiPgqesjoUoSJkegVV_p_i8KSJ14BZn86xZAzQq2qhBZ44BOOOH5tCHKP1K2BTe8bEF-7Fw',
  config: {
    apiKey: 'AIzaSyCNlLUNL_MKyp6wzUiAssl9luFhflsBaJk',
    authDomain: 'rebase-128ca.firebaseapp.com',
    databaseURL: 'https://rebase-128ca.firebaseio.com',
    projectId: 'rebase-128ca',
    storageBucket: '',
    messagingSenderId: '192664477779',
    appId: '1:192664477779:web:741e60beba3f6049'
  }
}
